import angular from 'angular';

angular.module('app.core').component('smartGrid', {
    templateUrl: require('./smart-grid.html'),
    bindings: {
        gridOptions: '<',
        gridDataPromise: '<'
    },
    transclude: true
});
